import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { Visible } from 'coreOld/components';
import { Icon } from 'coreOld/elements';

interface IProps {
  text: string;
  onClick?: () => void;
}

type CellWrapperProps = { onClick?: () => void; children?: ReactNode };

export const CellWrapper = styled.div<CellWrapperProps>`
  display: flex;
  text-align: center;
  transform: rotate(303deg);
  padding: 40px 0;
  justify-content: center;

  ${({ onClick }) =>
    onClick &&
    css`
      :hover {
        cursor: pointer;
      }
    `}
`;

export const IconWrapper = styled.div`
  transform: rotate(280deg);
  margin-left: 5px;
`;

const RotatedHeader = ({ text, onClick }: IProps) => {
  return (
    <CellWrapper onClick={onClick}>
      {text}

      <Visible when={Boolean(onClick)}>
        <IconWrapper>
          <Icon name={Icon.PENCIL} />
        </IconWrapper>
      </Visible>
    </CellWrapper>
  );
};

export default RotatedHeader;
